import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_LOVE: TStep[] = [
  {
    pageId: PageId.DOG_SEX_LOVE,
  },
  {
    pageId: PageId.DOG_AGE_LOVE,
  },
  {
    pageId: PageId.URGE_LOVE,
  },
  {
    pageId: PageId.FEELINGS_LOVE,
  },
  {
    pageId: PageId.URGE_1_LOVE,
  },
  {
    pageId: PageId.TALKING_LOVE,
  },
  {
    pageId: PageId.DOG_FOLLOW_LOVE,
  },
  {
    pageId: PageId.LICKING_LOVE,
  },
  {
    pageId: PageId.URGE_2_LOVE,
  },
  {
    pageId: PageId.BEHAVIOR_LOVE,
  },
  {
    pageId: PageId.FEEL_GUILTY_LOVE,
  },
  {
    pageId: PageId.URGE_3_LOVE,
  },
  {
    pageId: PageId.DOG_REACT_LOVE,
  },
  {
    pageId: PageId.SATISFIED_LOVE,
  },
  {
    pageId: PageId.BEHAVIOR_ISSUES_LOVE,
  },
  {
    pageId: PageId.YOUR_REACTION_LOVE,
  },
  {
    pageId: PageId.URGE_4_LOVE,
  },

  {
    pageId: PageId.DOG_BREED_LOVE,
  },
  {
    pageId: PageId.COMMANDS_LOVE,
  },
  {
    pageId: PageId.DOG_NAME_LOVE,
  },
  {
    pageId: PageId.LOVE_LOAD_SCREEN,
  },
  {
    pageId: PageId.DOG_PROFILE_LOVE,
  },
  {
    pageId: PageId.MOTIVATION_LOVE,
  },
  {
    pageId: PageId.FEEL_DOG_LOVE,
  },
  {
    pageId: PageId.FREQUENCY_LOVE,
  },
  {
    pageId: PageId.PREPARE_FLOW_LOVE,
  },
  {
    pageId: PageId.EMAIL_LOVE,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_LOVE,
  },
  {
    pageId: PageId.PERSONALIZED_PLAN_LOVE,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_LOVE,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_LOVE,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_2_LOVE,
  },
  {
    pageId: PageId.CANCEL_OFFER_LOVE,
  },
  {
    pageId: PageId.CHAT_UPSELL_LOVE,
  },
  {
    pageId: PageId.UPSELL_LOVE,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_LOVE,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_LOVE,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_LOVE.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_LOVE.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
